import {useState, useRef} from "react";import ProductDescription from "./ProductDescription";
import ProductPhotos from "./ProductPhotos";
import ProductInformation from "./description/ProductInformations";
import Product3DViewer from "./Product3DViewer";
import AppCanvas from "../../virtualTryOn/AppCanvas.jsx";

function Details({product, personal, update_p}) {
	const [show3D, setShow3D] = useState(false);
	const [showTryOn, setShowTryOn] = useState(false);
	const vtoRef = useRef(null);

	const modelUrl = product?.product?.models3d?.[0]?.url;
	const model2dUrl = product?.product?.models2d?.[0]?.url;
	const vtoSku = product?.product?.SKU;

	const mapSkuForVTO = sku => sku;
	const defaultFallbackSku = "rayban_aviator_or_vertFlash";
	const has3DModel = !!modelUrl;
	const has2DModel = !!model2dUrl;

	const title = product?.product?.name;
	const sku = product?.product?.SKU;
	const price = product?.product?.price_after;
	const compareAt = product?.product?.price_before;
	const shippingFree = !!product?.product?.shipping_free;
	const shippingDays = product?.product?.shipping_days;
	const inStock = product?.product?.stock_show !== false;

	const discountPct = (() => {
		const before = Number(compareAt);
		const after = Number(price);
		if (!before || !after || after >= before) return 0;
		return Math.round(((before - after) / before) * 100);
	})();

	// Handle try-on button click - Enhanced for both 2D and 3D
	const handleTryOnClick = () => {
		setShowTryOn(true);
		// Pass both 2D and 3D model URLs to enhanced AppCanvas
		setTimeout(() => {
			if (vtoRef.current) {
				// Set 2D model if available
				if (model2dUrl) {
					vtoRef.current.setGlassesImage(model2dUrl);
				}
				// Set 3D model if available
				if (modelUrl) {
					vtoRef.current.set3DModel(modelUrl);
				}
			}
		}, 100);
	};

	// Handle 3D model toggle
	const handle3DToggle = () => {
		setShow3D(!show3D);
	};

	return (
		<div
			className="d-flex flex-column flex-lg-row"
			style={{gap: 16}}
		>
			<div
				className=""
				style={{flex: 1, minWidth: 0}}
			>
				<div
					style={{
						position: "sticky",
						top: 16,
						background: "#fff",
						border: "1px solid #e6e6eb",
						borderRadius: 16,
						boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
						padding: 12,
						marginBottom: 16,
					}}
				>
					{/* Show controls if either 2D or 3D model exists */}
					{(has2DModel || has3DModel) && (
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								gap: 12,
								padding: "0 6px 12px 6px",
								flexWrap: "wrap",
								width: "100%",
							}}
						>
							<span
								style={{
									fontSize: 12,
									color: "#6b7280",
									flex: 1,
									minWidth: 180,
								}}
							>
								{show3D && has3DModel
									? "Drag to rotate • Scroll to zoom"
									: "Click thumbnails to view images"}
							</span>

							<div
								style={{
									display: "flex",
									alignItems: "center",
									gap: 8,
									flexShrink: 0,
								}}
							>
								{/* Virtual Try-On Button - Show if either 2D or 3D model exists */}
								{(has2DModel || has3DModel) && (
									<button
										onClick={handleTryOnClick}
										aria-label="Open virtual try-on"
										title="Try it on"
										style={{
											appearance: "none",
											border: "1px solid #e6e6eb",
											background: "#fff",
											color: "#111827",
											padding: "8px 12px",
											borderRadius: 8,
											fontSize: 13,
											fontWeight: 600,
											cursor: "pointer",
											display: "inline-flex",
											alignItems: "center",
											gap: 6,
											height: 36,
											lineHeight: 1,
											transition: "all 0.2s ease",
										}}
										onMouseEnter={e => {
											e.target.style.background =
												"#f8f9fa";
											e.target.style.borderColor =
												"#d1d5db";
										}}
										onMouseLeave={e => {
											e.target.style.background = "#fff";
											e.target.style.borderColor =
												"#e6e6eb";
										}}
									>
										<svg
											width="14"
											height="14"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round"
											aria-hidden
										>
											<path d="M3 10c4-4 14-4 18 0"></path>
											<path d="M8 14c1.5-1.5 6.5-1.5 8 0"></path>
											<circle
												cx="7"
												cy="14"
												r="2"
											></circle>
											<circle
												cx="17"
												cy="14"
												r="2"
											></circle>
										</svg>
										<span>Try it on</span>
									</button>
								)}

								{/* 3D Model Toggle - Only show if 3D model exists */}
								{has3DModel && (
									<div
										role="tablist"
										aria-label="Media toggle"
										style={{
											display: "inline-flex",
											position: "relative",
											borderRadius: 8,
											background: "#f3f4f6",
											padding: 3,
											gap: 3,
											minWidth: 200,
											height: 36,
											border: "1px solid #e5e7eb",
										}}
									>
										<div
											aria-hidden
											style={{
												position: "absolute",
												top: 3,
												bottom: 3,
												left: 3,
												width: `calc(50% - 3px)`,
												transform: show3D
													? "translateX(100%)"
													: "translateX(0)",
												transition:
													"transform 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
												background: "#ffffff",
												borderRadius: 6,
												boxShadow:
													"0 1px 2px rgba(0,0,0,0.06)",
											}}
										/>
										<button
											role="tab"
											aria-selected={!show3D}
											onClick={() => setShow3D(false)}
											onKeyDown={e => {
												if (e.key === "ArrowRight")
													setShow3D(true);
											}}
											style={{
												appearance: "none",
												border: "none",
												background: "transparent",
												color: !show3D
													? "#111827"
													: "#6b7280",
												padding: "6px 10px",
												borderRadius: 6,
												fontSize: 13,
												fontWeight: 600,
												cursor: "pointer",
												position: "relative",
												zIndex: 1,
												display: "inline-flex",
												alignItems: "center",
												justifyContent: "center",
												gap: 6,
												outline: "none",
												transition: "color 0.15s ease",
												minWidth: 92,
												height: 30,
											}}
										>
											<svg
												width="14"
												height="14"
												viewBox="0 0 24 24"
												fill="none"
												stroke="currentColor"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
												aria-hidden
											>
												<rect
													x="3"
													y="3"
													width="18"
													height="18"
													rx="2"
													ry="2"
												></rect>
												<circle
													cx="8.5"
													cy="8.5"
													r="1.5"
												></circle>
												<path d="M21 15l-5-5L5 21"></path>
											</svg>
											<span>Images</span>
										</button>
										<button
											role="tab"
											aria-selected={show3D}
											onClick={() => setShow3D(true)}
											onKeyDown={e => {
												if (e.key === "ArrowLeft")
													setShow3D(false);
											}}
											style={{
												appearance: "none",
												border: "none",
												background: "transparent",
												color: show3D
													? "#111827"
													: "#6b7280",
												padding: "6px 10px",
												borderRadius: 6,
												fontSize: 13,
												fontWeight: 600,
												cursor: "pointer",
												position: "relative",
												zIndex: 1,
												display: "inline-flex",
												alignItems: "center",
												justifyContent: "center",
												gap: 6,
												outline: "none",
												transition: "color 0.15s ease",
												minWidth: 92,
												height: 30,
											}}
										>
											<svg
												width="14"
												height="14"
												viewBox="0 0 24 24"
												fill="none"
												stroke="currentColor"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
												aria-hidden
											>
												<path d="M12 2l7 4v8l-7 4-7-4V6z"></path>
												<path d="M12 22V14"></path>
												<path d="M19 6l-7 4-7-4"></path>
											</svg>
											<span>3D Model</span>
										</button>
									</div>
								)}
							</div>
						</div>
					)}

					{/* Content display */}
					{show3D && has3DModel ? (
						<Product3DViewer modelUrl={modelUrl} />
					) : (
						<ProductPhotos images={product?.product?.images} />
					)}
				</div>
				<div className="mt-3 d-none d-lg-block">
					<ProductInformation desc={product?.product?.desc} />
				</div>
			</div>

			{/* Right: Product details */}
			<div style={{flex: 1, minWidth: 0}}>
				<ProductDescription
					product={product}
					personal={personal}
					update_p={update_p}
				/>
			</div>

			{/* Virtual Try-On Modal */}
			{showTryOn && (
				<div
					role="dialog"
					aria-modal="true"
					aria-labelledby="vto-modal-title"
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						background: "rgba(0, 0, 0, 0.8)",
						backdropFilter: "blur(4px)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						zIndex: 10000,
						padding: "20px",
						animation: "fadeIn 0.3s ease-out",
					}}
				>
					<div
						style={{
							background: "#ffffff",
							borderRadius: "20px",
							width: "min(1200px, 95vw)",
							height: "min(700px, 90vh)",
							position: "relative",
							overflow: "hidden",
							display: "flex",
							flexDirection: "column",
							boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
							border: "1px solid rgba(255, 255, 255, 0.1)",
						}}
					>
						{/* Header */}
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								padding: "20px 24px 16px",
								borderBottom: "1px solid #f1f1f1",
								background: "#fafafa",
							}}
						>
							<div>
								<h3
									id="vto-modal-title"
									style={{
										margin: 0,
										fontSize: "18px",
										fontWeight: 700,
										color: "#111827",
									}}
								>
									{has2DModel && has3DModel
										? "Virtual Try-On - 2D & 3D"
										: has3DModel
										? "Virtual Try-On - 3D"
										: "Virtual Try-On"}
								</h3>
								<p
									style={{
										margin: "4px 0 0 0",
										fontSize: "14px",
										color: "#6b7280",
									}}
								>
									{has2DModel && has3DModel
										? "Position your face in the camera view. Toggle between 2D and 3D models."
										: has3DModel
										? "Position your face in the camera view to experience the 3D model."
										: "Position your face in the camera view"}
								</p>
							</div>
							<button
								aria-label="Close virtual try-on"
								onClick={() => setShowTryOn(false)}
								style={{
									appearance: "none",
									border: "none",
									background: "rgba(0, 0, 0, 0.05)",
									borderRadius: "50%",
									width: "40px",
									height: "40px",
									cursor: "pointer",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									fontSize: "20px",
									fontWeight: "normal",
									color: "#4b5563",
									transition: "all 0.2s ease",
								}}
								onMouseEnter={e => {
									e.target.style.background =
										"rgba(0, 0, 0, 0.1)";
									e.target.style.transform = "scale(1.1)";
									e.target.style.color = "#111827";
								}}
								onMouseLeave={e => {
									e.target.style.background =
										"rgba(0, 0, 0, 0.05)";
									e.target.style.transform = "scale(1)";
									e.target.style.color = "#4b5563";
								}}
							>
								×
							</button>
						</div>

						{/* Content */}
						<div
							style={{
								display: "grid",
								gridTemplateColumns: "1fr 400px",
								flex: 1,
								overflow: "hidden",
							}}
						>
							{/* Left: Camera View */}
							<div
								style={{
									background: "#000",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									position: "relative",
									overflow: "hidden",
								}}
							>
								<AppCanvas
									ref={vtoRef}
									glassesImageUrl={model2dUrl}
									model3DUrl={modelUrl}
								/>
								<div
									style={{
										position: "absolute",
										bottom: "16px",
										left: "16px",
										right: "16px",
										background: "rgba(0, 0, 0, 0.7)",
										color: "white",
										padding: "12px 16px",
										borderRadius: "8px",
										fontSize: "14px",
										textAlign: "center",
										backdropFilter: "blur(10px)",
									}}
								>
									{has2DModel && has3DModel
										? "💡 Make sure your face is well-lit and centered. Use the toggle to switch between 2D and 3D models."
										: has3DModel
										? "💡 Make sure your face is well-lit and centered. Experience the realistic 3D model."
										: "💡 Make sure your face is well-lit and centered in the frame"}
								</div>
							</div>

							{/* Right: Preview & Info */}
							<div
								style={{
									padding: "24px",
									borderLeft: "1px solid #f1f1f1",
									background: "#fafafa",
									display: "flex",
									flexDirection: "column",
									gap: "24px",
									overflowY: "auto",
								}}
							>
								{/* Product Preview */}
								<div>
									<h4
										style={{
											margin: "0 0 12px 0",
											fontSize: "16px",
											fontWeight: 600,
											color: "#111827",
										}}
									>
										Product Preview
									</h4>
									<div
										style={{
											width: "100%",
											aspectRatio: "1 / 1",
											borderRadius: "12px",
											overflow: "hidden",
											border: "1px solid #e5e7eb",
											background: "#fff",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
									>
										{has2DModel ? (
											<img
												src={model2dUrl}
												alt="Glasses Preview"
												style={{
													width: "100%",
													height: "100%",
													objectFit: "contain",
													padding: "16px",
												}}
											/>
										) : has3DModel ? (
											<div
												style={{
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													height: "100%",
													color: "#6b7280",
													textAlign: "center",
													padding: "20px",
													flexDirection: "column",
												}}
											>
												<div
													style={{
														fontSize: "48px",
														marginBottom: "8px",
													}}
												>
													🎯
												</div>
												<p
													style={{
														margin: 0,
														fontSize: "14px",
													}}
												>
													3D Model Available
												</p>
												<p
													style={{
														margin: "4px 0 0 0",
														fontSize: "12px",
														color: "#9ca3af",
													}}
												>
													Use virtual try-on to view
												</p>
											</div>
										) : (
											<div
												style={{
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													height: "100%",
													color: "#6b7280",
													textAlign: "center",
													padding: "20px",
												}}
											>
												<div>
													<div
														style={{
															fontSize: "48px",
															marginBottom: "8px",
														}}
													>
														👓
													</div>
													<p style={{margin: 0}}>
														No Model Available
													</p>
												</div>
											</div>
										)}
									</div>
								</div>

								{/* Product Info - Show for both 2D and 3D models */}
								{(has2DModel || has3DModel) && (
									<div>
										<h4
											style={{
												margin: "0 0 12px 0",
												fontSize: "16px",
												fontWeight: 600,
												color: "#111827",
											}}
										>
											Product Details
										</h4>
										<div
											style={{
												background: "#fff",
												borderRadius: "8px",
												padding: "16px",
												border: "1px solid #e5e7eb",
											}}
										>
											<h5
												style={{
													margin: "0 0 8px 0",
													fontSize: "15px",
													fontWeight: 600,
													color: "#111827",
												}}
											>
												{title}
											</h5>
											<div
												style={{
													display: "flex",
													alignItems: "center",
													gap: "8px",
													marginBottom: "8px",
												}}
											>
												{compareAt > price && (
													<span
														style={{
															fontSize: "14px",
															color: "#6b7280",
															textDecoration:
																"line-through",
														}}
													>
														${compareAt}
													</span>
												)}
												<span
													style={{
														fontSize: "16px",
														fontWeight: 700,
														color: "#111827",
													}}
												>
													${price}
												</span>
												{discountPct > 0 && (
													<span
														style={{
															background:
																"#dc2626",
															color: "white",
															fontSize: "12px",
															fontWeight: 600,
															padding: "2px 6px",
															borderRadius: "4px",
														}}
													>
														-{discountPct}%
													</span>
												)}
											</div>
											<p
												style={{
													margin: 0,
													fontSize: "14px",
													color: "#6b7280",
													lineHeight: "1.5",
												}}
											>
												{has2DModel && has3DModel
													? "Try both 2D and 3D models to see how the glasses fit from different angles. Use the toggle to switch between models."
													: has3DModel
													? "Experience the 3D model to see how the glasses fit from different angles with realistic depth and positioning."
													: "Move your head naturally to see how the glasses fit from different angles."}
											</p>
										</div>
									</div>
								)}

								{/* Instructions */}
								<div>
									<h4
										style={{
											margin: "0 0 12px 0",
											fontSize: "16px",
											fontWeight: 600,
											color: "#111827",
										}}
									>
										Tips for Best Results
									</h4>
									<div
										style={{
											background: "#fff",
											borderRadius: "8px",
											padding: "16px",
											border: "1px solid #e5e7eb",
										}}
									>
										<ul
											style={{
												margin: 0,
												paddingLeft: "20px",
												fontSize: "14px",
												color: "#4b5563",
												lineHeight: "1.6",
											}}
										>
											<li>
												Ensure good lighting on your
												face
											</li>
											<li>
												Keep your face centered in the
												frame
											</li>
											<li>
												Maintain a neutral expression
											</li>
											<li>
												Turn your head slowly to see
												different angles
											</li>
											{has2DModel && has3DModel && (
												<li>
													Use the 2D/3D toggle to
													switch between model types
												</li>
											)}
											{has3DModel && (
												<li>
													3D models provide realistic
													depth and positioning
												</li>
											)}
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default Details;
